import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IntelliDose_img from "../../Assets/IntelliDose_img.webp";
import Bluelab_IntelliDose_img from "../../Assets/Bluelab_IntelliDose_img.webp";
import blb_blog_img from "../../Assets/blb_blog_img.webp";
import "./blog.css";
import "animate.css";
import "bootstrap-icons/font/bootstrap-icons.css";

function automatic_dosing_system_for_hydroponics() {
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowImage(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container fluid>
      <h1 className="text-center p-3">
        Automatic Dosing System for Hydroponics
      </h1>

      <Row className="m-5">
        <Col className="p-4 mt-5 textJustify" sm={12} md={6} lg={6}>
          <div className="d-flex justify-content-center">
            <img
              src={IntelliDose_img}
              className="img-fluid p-3 rounded"
              style={{ width: "100%", height: "600px" }}
              alt="Bluelab IntelliDose System"
            />
          </div>
        </Col>
        <Col className="p-4 textJustify" sm={12} md={6} lg={6}>
          <div id="blog1" className="border p-2">
            <p className="mt-3 text-justify">
              At <strong>Royal Green House Construction (RGCPL)</strong>, we
              empower farmers to embrace smart farming practices through
              advanced hydroponic technology. One of the most powerful
              innovations in modern agriculture is the{" "}
              <strong>Automatic Dosing System for hydroponics</strong>. This
              intelligent system revolutionizes nutrient delivery, offering
              precision, consistency, and enhanced productivity in soilless
              farming environments.
            </p>

            <h5 className="mt-4 mb-3 fw-bold">
              Top 5 Benefits of Using an Automatic Dosing System for Hydroponics
            </h5>

            <ol>
              <li>
                <strong>Precision in Nutrient Delivery:</strong>
                Manual nutrient mixing can lead to overfeeding or underfeeding,
                harming plant growth. An{" "}
                <strong>Automatic Dosing System for hydroponics</strong>{" "}
                provides real-time monitoring and ensures optimal nutrient
                balance, boosting plant health and maximizing crop yields.
              </li>
              <li>
                <strong>Time-Saving and Increased Efficiency:</strong>
                Automation eliminates the need for constant manual adjustments.
                The system intelligently manages pH, EC (Electrical
                Conductivity), and nutrient concentrations, freeing up your time
                to focus on other key farm operations.
              </li>
              <li>
                <strong>Cost-Effective in the Long Run:</strong>
                While the initial investment may seem high, this system
                significantly reduces nutrient and water wastage. It also
                minimizes crop loss due to human error, helping you save money
                and increase profitability.
              </li>
              <li>
                <strong>Consistent Growth Environment:</strong>A stable
                environment is critical for healthy plant growth. The automatic
                dosing system maintains optimal conditions continuously,
                creating a uniform growth environment that leads to
                better-quality produce.
              </li>
              <li>
                <strong>Data-Driven Decisions for Better Farming:</strong>
                Smart dosing systems collect and analyze data in real-time. This
                empowers farmers to make strategic decisions, troubleshoot
                issues early, and continuously optimize nutrient and water
                management.
              </li>
            </ol>
          </div>
        </Col>
      </Row>

      <Row className="m-5">
        <Col className="p-4 mt-5 textJustify" sm={12} md={6} lg={6}>
          <h3>Shop for Automatic Dosing Systems at RGCPL</h3>
          <p>
            Looking to upgrade your hydroponic farm with an advanced{" "}
            <strong>Automatic Dosing System for hydroponics</strong>? At RGCPL,
            we offer high-performance dosing solutions, including trusted brands
            like Bluelab. Visit us at{" "}
            <a
              href="https://royalgreenhouse.co.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://royalgreenhouse.co.in
            </a>{" "}
            or contact us at <a href="tel:+919960991166">+91-9960-991-166</a> to
            get expert guidance on automating your hydroponic setup.
          </p>
          <i>
            Invest in innovation today for a more productive and sustainable
            tomorrow.
          </i>
        </Col>

        <Col className="p-4 mt-5 textJustify" sm={12} md={6} lg={6}>
          <div className="d-flex justify-content-center">
            <img
              src={Bluelab_IntelliDose_img}
              className="img-fluid p-3 rounded"
              style={{ width: "100%", height: "600px" }}
              alt="Hydroponic automation tools"
            />
          </div>
        </Col>
      </Row>

      <Row className="m-5 justify-content-center">
        <Col className="p-4 mt-5 textJustify" sm={12} md={10} lg={8}>
          <div className="d-flex justify-content-center">
            <img
              src={blb_blog_img}
              className="img-fluid p-3 rounded"
              style={{ width: "100%", height: "600px" }}
              alt="Automatic dosing system for hydroponics"
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default automatic_dosing_system_for_hydroponics;
